import http from "../../helpers/http";
import * as helpers from "../../helpers/api";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
    FETCH_MEDIA_CONTENT,
    FETCH_MEDIA_CONTENT_SUCCESS,
    FETCH_MEDIA_CONTENT_FAILED,
    MEDIA_DELETE__MESSAGE,
    MEDIA_DELETE_MESSAGE_SUCCESS,
    MEDIA_DELETE__MESSAGE_FAILED
} from "./actionTypes";

export const fetchMedia = () => (dispatch) => {
    dispatch({
        type: FETCH_MEDIA_CONTENT,
        payload: null
    });
    http
        .get("media")
        .then(({ data }) => {
            dispatch({
                type: FETCH_MEDIA_CONTENT_SUCCESS,
                payload: data
            });
        })
        .catch((error) => {
            dispatch({
                type: FETCH_MEDIA_CONTENT_FAILED,
                payload: error
            });
        });
};


export const deleteMedia = (formData) => (dispatch) => {
    dispatch({
        type: MEDIA_DELETE__MESSAGE,
        payload: null
    });
    http
        .post('delete-media/' + formData, helpers.doObjToFormData(formData))
        .then(({ data }) => {
            if (data.status) {
                toast.success(
                    `${data.msg}`,
                    TOAST_SETTINGS
                );
                setTimeout(() => {
                    window.location.replace("/media");
                }, 2000);
                dispatch({
                    type: MEDIA_DELETE_MESSAGE_SUCCESS,
                    payload: data
                });
            } else {
                toast.error(
                    <Text string={data.msg} parse={true} />,
                    TOAST_SETTINGS
                );
                dispatch({
                    type: MEDIA_DELETE__MESSAGE_FAILED,
                    payload: null
                });
            }
        })
        .catch((error) => {
            dispatch({
                type: MEDIA_DELETE__MESSAGE_FAILED,
                payload: error
            });
        });
};